// import Button from "@rezdy/components/Button";
import AuthRoute from './AuthRoute';
import Field from '@rezdy/components/Form/Field';
import PhoneInput from '@rezdy/components/Form/FormElements/PhoneInput';
import React from 'react';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import routes from '../constants/routes';
import routing from '../services/routing';
import { withTranslation } from 'react-i18next';
export class ChangeProfile extends AuthRoute {
    // state = {
    //     message: "",
    //     data: {},
    //     isDirty: false,
    //     isDisabled: true,
    //     isLoading: false,
    //     isSignedIn: false,
    // };

    onSubmit = () => {
        const { action, i18n } = this.props;
        const { isLoading, data } = this.state;

        if (!isLoading) {
            this.setState({ isLoading: true }, async () => {
                try {
                    await action(data);
                    this.setState({
                        data: {},
                        isDirty: false,
                        isLoading: false,
                        message: i18n.t('messages.profileSaved'),
                    });
                } catch (error) {
                    this.setState({
                        isDirty: true,
                        isLoading: false,
                        message: error.message,
                    });
                }
            });
        }
    };

    onSecondaryClick = () => {
        routing.push(routes.PROFILE);
    };

    onFieldChange = (formData: { id?: string; value: string; isValid?: boolean }) => {
        const { id, value } = formData;
        const { data } = this.state;

        if (id !== undefined) {
            this.setState({
                data: {
                    ...data,
                    [id]: value,
                },
            });
        }
    };

    onPhoneChange = ({ code, number }: any) => {
        const { data } = this.state;
        this.setState({
            data: {
                ...data,
                mobile: `+${code}${number}`,
            },
        });
    };

    renderBody = () => {
        const { i18n } = this.props;
        const { firstName, lastName, phoneNumber } = this.props.data;
        return (
            <React.Fragment>
                <Field label={i18n.t('firstname')} name="firstname">
                    <TextInput defaultValue={firstName ?? ''} onChange={this.onFieldChange} />
                </Field>
                <Field label={i18n.t('lastname')} name="lastname">
                    <TextInput defaultValue={lastName ?? ''} onChange={this.onFieldChange} />
                </Field>
                <Field label={i18n.t('mobile')} name="mobile">
                    <PhoneInput defaultValue={phoneNumber ?? ''} onChange={this.onPhoneChange} />
                </Field>
            </React.Fragment>
        );
    };
}

export default withTranslation()(ChangeProfile);
